export const SentSaleOfferStatus = Object.freeze({
    NS: Symbol('NS'),
    S: Symbol('S'),
});

export function getStatusText(status) {
    return {
        [SentSaleOfferStatus.NS]: 'Nieobsłużona',
        [SentSaleOfferStatus.S]: 'Obsłużona',
    }[SentSaleOfferStatus[status]];
}